<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group> -->
        <!-- <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'type'">
          ประเภทให้คำปรึกษา/แนะนำ
          <br />
          ด้านร้องทุกข์
        </span>
        <span v-else-if="props.column.field == 'subject'">
          เรื่องให้คำปรึกษา/แนะนำ
          <br />
          ช่องทาง
        </span>
        <span v-else>
          {{ props.column.label }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">

        <!-- Column: Name -->
        <span v-if="props.column.field === 'codeList'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.verifyCode }}</span>
        </span>

        <!-- Column: Name -->
        <!-- <span v-if="props.column.field === 'verifyDep'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.verifyDepDescription }}</span>
          <br />
          <span class="">{{ provinceName(props.row.provinceOfficeId) }}</span>
        </span> -->

        <!-- Column: Name -->
        <span v-if="props.column.field === 'compName'" class="text-nowrap">
          {{ props.row.compName }}
        </span>

        <span
          v-if="props.column.field === 'verifyMinistry'"
          class="text-nowrap"
        >
          <span class="text-nowrap"
            >{{ props.row.verifyMinistryDescription }}
          </span>
          <br />
          <span
            class=""
            v-if="
              props.row.resultDescription !== null &&
                props.row.resultDescription !== ''
            "
            >{{ props.row.resultDescription.substring(0, 97) }}...</span
          >
        </span>

        <span v-if="props.column.field === 'verifyDate'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.varifyDateStr }} <br /></span>
          <span v-if="props.row.verifyFlag === 1" class="text-nowarp"
            ><feather-icon icon="CheckIcon" class="mr-50" /> แนะนำ</span
          >
          <span v-else-if="props.row.verifyFlag === 2" class="text-nowarp"
            ><feather-icon icon="XIcon" class="mr-50" /> ดำเนินคดี</span
          >
        </span>

        <!-- Column: Name -->
        <span v-if="props.column.field === 'cDate'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.cDateStr }}</span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item @click="onManageBtnClicked(props.row.verifyId)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>แก้ไข</span>
              </b-dropdown-item>
              <b-dropdown-item @click="onDeleteBtnClicked(props.row.verifyId)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>ลบ</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./commonTableHeader.js";
import * as verifyStore from "@/store/api/verify/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      provinces: [],
      pageLength: 10,
      dir: false,
      codeBasic,
      columns:
        this.mode == "List" || this.mode == "Group"
          ? TableHeaders
          : TableHeadersGroupProcess,
      rows: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.onSearchSubmit({});

    const _this = this;

    storeMaster
      .getProvince()
      .then(function(response) {
        _this.provinces = response.data.data;
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      });
  },
  methods: {
    isProvincialOfficer() {
      if ("25e8af7c-d072-47fd-985b-fb1eefc44764" === userData.selectedRole()) {
        return true;
      }

      return false;
    },
    provinceName(provinceCode) {
      const _this = this;

      if (_this.provinces === null) return "";

      var province = _this.provinces.find((value) => {
        return value.value == provinceCode;
      });

      if (province !== null && province !== undefined) return province.text;
      return "";
    },
    onSearchSubmit(params) {

      params.createBy = userData.userId();
      console.log('ทดสอบ', params);

      if (this.isProvincialOfficer()) {
        params.provinceCode = userData.province();
      }
      var _this = this;
      verifyStore
        .search(params)
        .then(function(response) {
          // handle success
          console.log("then", response);
          _this.rows = response.data.data;
          console.log("result", _this.rows);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
        });
    },
    onManageBtnClicked(id) {
      window.open(
        this.$router.resolve({ name: "VerifyManage", query: { id } }).href,
        "_blank"
      );
    },
    onDeleteBtnClicked(id) {
      const _this = this;

      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          verifyStore
            .deleteItem(id)
            .then((response) => {
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                this.onSearchSubmit({});
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onComplainSend(id) {
      this.$emit("handleSend", id);
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
